module.exports = __webpack_public_path__ + "img/postranice.c7b1b5bc.jpg";